import { useRun } from '@/hooks/useSwr';
import { RunSchema } from '@/types/schema';

export function useRootRunAndRun(
  traceId: string | null | undefined,
  runId: string | null | undefined,
  shareToken?: {
    datasetShareToken?: string;
    runShareToken?: string;
  },
  runFallbackRef?: React.RefObject<Record<string, RunSchema>>,
  withContents?: boolean,
  sessionId?: string
) {
  const runFallback = runFallbackRef?.current?.[runId ?? ''];

  const run = useRun({
    id: runId,
    options: {
      keepPreviousData: !runFallback,
      fallbackData: runFallback,
    },
    shareToken,
    withContents,
    excludeSerialized: true,
    sessionId,
  });

  const realTraceId = traceId ?? (runId && run.data ? run.data.trace_id : null);

  const rootRun = useRun({
    // When a public run is loaded, the rootRunId can be null since shared run
    // might not be the root run. So "rootRun" is cached with id: null and shareToken
    // is used to load the node.
    id: shareToken ? undefined : realTraceId,
    options: {
      // no need to prime root run anymore because we don't need to root run
      // to fetch the run tree children.
      keepPreviousData: false,
    },
    shareToken,
    excludeSerialized: true,
    sessionId,
  });

  return {
    rootRun: rootRun.data,
    run,
  };
}
